import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SliderWrapper from "jd-library/SliderWrapper";
import historyHandler from "jd-library/historyHandler";
import BrandManufSlider from "./BrandManufSlider";
import SelectSupplierSlider from "./SelectSupplierSlider";
import { updateEditProductDetail } from '../../../actions/products';
import { showToastMessage } from '../../../actions/toastmessage';
import SwitchButtonWithMovingInput from '../../../common/Switch-Button-with-Moving-Input/SwitchButtonWithMovingInput';
import style from "./stock-reorder.scss";
import withRipple from 'jd-library/withRipple';
import { fetchSupplierData } from "../../../utills";
import { setVariantProductData } from "../../../actions/variants";

export const StockReorder = React.memo((props) => {
    const { fromSingleVariant=false,  variantPresent=false, currentVariantIndex=null, variantData=null, onHiddenForVariant=null} = props;
    const [stockReorderData, setStockReorderData] = useState({});
    const [isScrolled, setScrolled] = useState(0);
    const [show, toggleSlider] = useState(fromSingleVariant || false);
    const [brandManufSlider, setBrandManufSlider] = useState(null);
    const [supSlider, setSupSlider] = useState(null);
    const [srData, setsrData] = useState([]);

    const sliderWrapperProps = {
        slider: {
            className: style[`stock-reorder-slider`],
        },
        onScroll: (e) => {
            setScrolled(e.target.scrollTop > 5);
        },
        header: {
            heading: variantPresent && !fromSingleVariant ? "Associated Suppliers" : "Stock Reorder Details",
            className: 'stock-reorder-header',
            raised: isScrolled,
            hasBorder: !isScrolled,
            leftIcons: [{
                className: 'icon-HDRback',
                onClick: e => {
                    if(!fromSingleVariant) initializeData();

                    historyHandler.closeCurrent();
                }
            }]
        },
        footer: {
            btnProps: [
                {
                    children: "Save",
                    onClick: () => {
                        // for variantPresent                        
                        if(variantPresent && !fromSingleVariant) {
                            setTimeout(() => {
                                props.updateEditProductDetail([
                                    {
                                        key: 'brandName',
                                        value: stockReorderData.brandName
                                    },
                                    {
                                        key: 'manufacturerName',
                                        value: stockReorderData.manufacturerName
                                    },
                                    {
                                        key: 'associatedSuppliers',
                                        value: stockReorderData.associatedSuppliers
                                    },
                                    {
                                        key: 'associatedSuppliersDetails',
                                        value: stockReorderData.associatedSuppliersDetails
                                    }
                                ]);
                                historyHandler.closeCurrent();
                            }, 300);
                        
                        // for current variant editing
                        } else if(variantPresent && fromSingleVariant) {
                            var temp = {
                                reorderLevel: stockReorderData.reorderLevel,
                                reorderQuantity: stockReorderData.reorderQuantity
                            };
                            if(!(stockReorderData.isAutoReorderLevel || String(stockReorderData.reorderLevel).length)){
                                temp.reorderLevel = '0';
                            }
                            if(!(stockReorderData.isAutoReorderQuantity || String(stockReorderData.reorderQuantity).length)){
                                temp.reorderQuantity = '1';
                            }
                            let variandD = [...variantData];
                            variandD[currentVariantIndex] = {
                                ...variandD[currentVariantIndex],
                                isAutoReorderLevel: stockReorderData.isAutoReorderLevel ? true : false,
                                isAutoReorderQuantity: stockReorderData.isAutoReorderQuantity ? true : false,
                                reorderLevel: temp.reorderLevel,
                                reorderQuantity: temp.reorderQuantity
                            }
                            setTimeout(() => {
                                props.setVariantProductData([...variandD]);
                                historyHandler.closeCurrent();
                            }, 300);

                        // for normal product
                        } else {
                            var temp = {
                                reorderLevel: stockReorderData.reorderLevel,
                                reorderQuantity: stockReorderData.reorderQuantity
                            };
                            if(!(stockReorderData.isAutoReorderLevel || String(stockReorderData.reorderLevel).length)){
                                temp.reorderLevel = '0';
                            }
                            if(!(stockReorderData.isAutoReorderQuantity || String(stockReorderData.reorderQuantity).length)){
                                temp.reorderQuantity = '1';
                            }
                            
                            setTimeout(() => {
                                props.updateEditProductDetail([
                                    {
                                        key: 'reorderLevel',
                                        value: temp.reorderLevel
                                    },
                                    {
                                        key: 'reorderQuantity',
                                        value: temp.reorderQuantity
                                    },
                                    {
                                        key: 'isAutoReorderLevel',
                                        value: stockReorderData.isAutoReorderLevel
                                    },
                                    {
                                        key: 'isAutoReorderQuantity',
                                        value: stockReorderData.isAutoReorderQuantity
                                    },
                                    {
                                        key: 'brandName',
                                        value: stockReorderData.brandName
                                    },
                                    {
                                        key: 'manufacturerName',
                                        value: stockReorderData.manufacturerName
                                    },
                                    {
                                        key: 'associatedSuppliers',
                                        value: stockReorderData.associatedSuppliers
                                    },
                                    {
                                        key: 'associatedSuppliersDetails',
                                        value: stockReorderData.associatedSuppliersDetails
                                    }
                                ]);
                                historyHandler.closeCurrent();
                            }, 300);
                        }                        
                    },
                },
            ],
        },
        onHidden: () => {
            toggleSlider(false);
            onHiddenForVariant ? onHiddenForVariant() : null;
        },
        animateChildren: false,
    };

    const initializeData = () => {
        var temp = props.productData ? JSON.parse(JSON.stringify(props.productData)) : {}; // Cloning without reference
        if(temp?.associatedSuppliersDetails?.length){
            temp.associatedSuppliers = temp.associatedSuppliersDetails.map(supplier=>supplier.vendorMongoId || supplier._id.$oid) //Fix production order issue
        }
        if(fromSingleVariant) {
            var temp = variantData[currentVariantIndex] ? JSON.parse(JSON.stringify(variantData[currentVariantIndex])) : {}; // Cloning without reference
            setStockReorderData({
                isAutoReorderLevel: temp?.isAutoReorderLevel || false,
                isAutoReorderQuantity: temp?.isAutoReorderQuantity || false,
                reorderLevel: temp?.reorderLevel || 0,
                reorderQuantity: temp?.reorderQuantity || 0,
            });
        } else if(variantPresent) {            
            setStockReorderData({
                brandName: temp?.brandName || '',
                manufacturerName: temp?.manufacturerName || '',
                associatedSuppliers: temp?.associatedSuppliers || [],
                associatedSuppliersDetails: temp?.associatedSuppliersDetails || []
            });
        } else {
            setStockReorderData({
                isAutoReorderLevel: temp?.isAutoReorderLevel || false,
                isAutoReorderQuantity: temp?.isAutoReorderQuantity || false,
                reorderLevel: temp?.reorderLevel || 0,
                reorderQuantity: temp?.reorderQuantity || 0,
                brandName: temp?.brandName || '',
                manufacturerName: temp?.manufacturerName || '',
                associatedSuppliers: temp?.associatedSuppliers || [],
                associatedSuppliersDetails: temp?.associatedSuppliersDetails || []
            });
        }
        
    }

    useEffect(() => {
        if (props.productData || fromSingleVariant || variantPresent) {
            initializeData();
        }
    }, [props.productData, fromSingleVariant, variantPresent]);

    useEffect(() => {
        let subHeading = [];
        if (stockReorderData.isAutoReorderLevel) {
            subHeading.push({
                key: 'Auto Maintain Reorder Point',
                value: ''
            });
        } else {
            subHeading.push({
                key: 'Reorder Level',
                value: stockReorderData.reorderLevel
            });
        }
        if (stockReorderData.isAutoReorderQuantity) {
            subHeading.push({
                key: 'Auto Maintain Reorder Quantity',
                value: ''
            });
        } else {
            subHeading.push({
                key: 'Reorder Quantity',
                value: stockReorderData.reorderQuantity
            });
        }
        setsrData(subHeading);
    }, [stockReorderData]);

    //Auto Maintain
    const autoMaintainProps = {
        level: {
            type: "level",
            label: "Auto Maintain Re-Order Level",
            content: "In order to edit Reorder level manually, turn off to 'Maintain a reorder level for all products based on peak inventory'.",
            inputProps: {
                inputLabel: "Re-Order Level",
                toggle: stockReorderData.isAutoReorderLevel,
                value: stockReorderData.reorderLevel || '',
                onChange: (type, value, toggleInput) => {
                    setStockReorderData({ ...stockReorderData, reorderLevel: value, isAutoReorderLevel: toggleInput });
                }
            },
        },
        quantity: {
            type: "quantity",
            label: "Auto Maintain Re-Order Quantity",
            content: "In order to edit Reorder quantity manually, turn off to 'Maintain reorder quantity for all products based on peak inventory'.",
            inputProps: {
                class: style['reorder-input'],
                inputLabel: "Re-Order Quantity",
                toggle: stockReorderData.isAutoReorderQuantity,
                value: stockReorderData.reorderQuantity || '',
                onChange: (type, value, toggleInput) => {
                    setStockReorderData({ ...stockReorderData, reorderQuantity: value, isAutoReorderQuantity: toggleInput });
                }
            },
        }
    };

    const deleteSupplierData = (data) => {
        if(data.length && stockReorderData.associatedSuppliers && stockReorderData.associatedSuppliers.length){
            let index = stockReorderData.associatedSuppliers.findIndex((vendorMongoId)=>{
                if(vendorMongoId == data[0].vendorMongoId){
                    return true;
                }
            })
            if(index!=-1){
                let temp = stockReorderData;
                temp.associatedSuppliers.splice(index,1);
                temp.associatedSuppliersDetails.splice(index,1);
                setStockReorderData({...temp});
            }
        }
    }

    const addSupplierData = (data, brandName, manufacturerName) => {
        let temp = stockReorderData;
        temp.brandName = brandName;
        temp.manufacturerName = manufacturerName;
        data.map((supplier)=>{
            let index = -1;
            if(stockReorderData.associatedSuppliers && stockReorderData.associatedSuppliers.length){
                index = stockReorderData.associatedSuppliers.findIndex((vendorMongoId)=>{
                    if(supplier.vendorMongoId == vendorMongoId){
                        return true;
                    }
                })
            }
            if(index == -1){
                temp.associatedSuppliers.push(supplier.vendorMongoId);
                temp.associatedSuppliersDetails.push(supplier);
            }
        })
        setStockReorderData({...temp});
    }

    // Associated Supplier
    const addSupplier = (data) => {
        var {supKeys, supData} = data;
        setStockReorderData({ ...stockReorderData, associatedSuppliersDetails: supData, associatedSuppliers: supKeys });
    }

    const scrollElement = (e) => {
        if(e.currentTarget){
            const ele = e.currentTarget;
            setTimeout(()=>{
                ele.scrollIntoView({ behavior: "smooth", block: "center" })
            }, 450) //Keyboard open delay
        }
    }

    const StockReorderWithRipple = withRipple((props) => {
        return (
            <div className={`${style["stock-reorder-container"]} ${props.rippleClass}`} {...props.rippleHandler}>
                <div className={`${style["container"]}`}>
                    <div className={`${style["left-side"]}`}>
                        <div className={style["head-text"]}>
                            <span>{variantPresent ? 'Associated Suppliers' : 'Stock Reorder Details'}</span>
                        </div>
                        {!variantPresent && <div className={style["upfront-data"]}>
                            {srData.map((ele, index) => (
                                <span key={'stck-reorder-'+index}>
                                    {ele.key} {(ele.value && ele.value >= 0) ? ': ' + ele.value : ''}{" "}
                                    {index == srData.length - 1 ? '' : (
                                        <i className="circle-dot"></i>
                                    )}{" "}
                                </span>
                            ))}
                        </div>}
                    </div>
                    <i className={"icon-Next"}></i>
                </div>
                <div className={style["fake-border"]}></div>
                {props.renderRipple()}
            </div>
        )
    })
    const getSupplierSubTitle = () => {
        var info = '';
        var addedSuppliersCount = stockReorderData.associatedSuppliersDetails ? stockReorderData.associatedSuppliersDetails.length : 0;
        if(addedSuppliersCount){
            if(addedSuppliersCount > 1){
                info = addedSuppliersCount + ' Supplier(s) Selected';
            }else{
                info = stockReorderData.associatedSuppliersDetails[0].companyName;
            }
        }
        return info;
    }
    const navigateBtns = [{
        label: 'Brand',
        info: stockReorderData.brandName,
        onClick: () => {
            setBrandManufSlider({
                type: 'brand',
                value: stockReorderData.brandName,
                onHidden: () => setBrandManufSlider(null),
                onSelect: (value) => {
                    if(stockReorderData.brandName){
                        fetchSupplierData(stockReorderData.brandName,'',false,(data)=>{
                            deleteSupplierData(data);
                            fetchSupplierData(value,stockReorderData.manufacturerName,true,addSupplierData);
                        });
                    }else{
                        fetchSupplierData(value,stockReorderData.manufacturerName,true,addSupplierData);
                    }
                }
            });
        }
    },{
        label: 'Manufacturer',
        info: stockReorderData.manufacturerName,
        onClick: () => {
            setBrandManufSlider({
                type: 'manufacturer',
                value: stockReorderData.manufacturerName,
                onHidden: () => setBrandManufSlider(null),
                onSelect: (value) => {
                    if(stockReorderData.manufacturerName){
                        fetchSupplierData('',stockReorderData.manufacturerName,false,(data)=>{
                            deleteSupplierData(data);
                            fetchSupplierData(stockReorderData.brandName,value,true,addSupplierData);
                        });
                    }else{
                        fetchSupplierData(stockReorderData.brandName,value,true,addSupplierData);
                    }
                }
            });
        }
    },{
        label: 'Supplier',
        info: getSupplierSubTitle(),
        onClick: () => {
            setSupSlider({
                addedSuppliers: Array.isArray(stockReorderData.associatedSuppliersDetails) ? stockReorderData.associatedSuppliersDetails : [stockReorderData.associatedSuppliersDetails],
                addedSupplierIds: Array.isArray(stockReorderData.associatedSuppliers) ? stockReorderData.associatedSuppliers : [stockReorderData.associatedSuppliers],
                onHidden: () => setSupSlider(null),
                onContinue: (data) => {
                    addSupplier(data);
                }
            });
        }
    }];
    const NavigateBtn = withRipple((props) => {
        const {btn} = props;
        return (
            <div className={`${style["navigate-btn"]} ${btn.info ? 'reorder-nav' : ''} ${props.rippleClass}`} {...props.rippleHandler} onClick={btn.onClick}>
                <div className={style["btn-label"]}>
                    {btn.label}
                    <div className={style["sub-title"]}>{btn.info}</div>
                </div>
                {/* <div className={style["divider"]}></div> */}
                <span className='icon-Next'></span>
                {props.renderRipple()}
            </div>
        )
    });

    return (
        <>
            {!fromSingleVariant ? <div
                
                onClick={function(e){
                    setTimeout(function(){
                        toggleSlider(true)
                    }, 250)
                }}
            >
               <StockReorderWithRipple 
                    variantPresent={props.variantPresent}
               />
                
            </div> : null}
            {show ? (
                <SliderWrapper {...sliderWrapperProps}>
                    <div className={style['reorder-wrapper']}>
                        {/* Auto Maintain */}
                        {(!variantPresent || fromSingleVariant) ? <div className={style['auto-maintain-reorder']}>
                            <SwitchButtonWithMovingInput {...autoMaintainProps.level} />
                            <SwitchButtonWithMovingInput {...autoMaintainProps.quantity} />
                        </div> : null}
                        {!fromSingleVariant ? <div className={style['navigate-btn-holder']}>
                            {navigateBtns.map((btn, index) => (
                                <NavigateBtn key={'navibtn-reorder-maintain-'+index} btn={btn} />
                            ))}
                        </div> : null}
                    </div>
                </SliderWrapper>
            ) : null
            }
            {brandManufSlider && !fromSingleVariant ? <BrandManufSlider {...brandManufSlider} /> : null}
            {supSlider && !fromSingleVariant ? <SelectSupplierSlider {...supSlider} /> : null}
        </>
    );
});

StockReorder.propTypes = {
    prop: PropTypes
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        variantPresent: state.variants.variantProductData.length > 0,
        variantData: state.variants.variantProductData
    };
};

const mapDispatchToProps = {
    updateEditProductDetail,
    showToastMessage,
    setVariantProductData
};

export default connect(mapStateToProps, mapDispatchToProps)(StockReorder);
